import React from 'react';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  gridLogo: {
    cursor: 'pointer'
  },
  container: {
    maxWidth: '214px',
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  gridButtons: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },    

  },
  buttonDefault: {
    marginRight: theme.spacing(2),
  },
}));

export default (props) => {
  const history = useHistory();
  const Home = async () => {
    history.push("/");
  }
  const Login = async () => {
    history.push("/login");
  }
  const Register = async () => {
    history.push("/register");
  }
  const classes = useStyles();
  return (
    <AppBar position="static" color="default" className={classes.root} elevation={2}>
      <Container>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12} md={9} onClick={() => Home()} className={classes.gridLogo}>
            <div className={classes.container} style={{maxWidth: props.config.maxWidth}}><img src={props.config.imageUrl} alt={props.config.imageAlt} className={classes.image} /></div>
          </Grid>
          <Grid item xs={12} md={3} className={classes.gridButtons}>
            {props.isAuthenticated &&
              <div>
                <Button variant="outlined" color="secondary" className={classes.buttonDefault} onClick={() => Home()}>Home</Button>
                <Button variant="contained" color="secondary" disableElevation onClick={() => props.Logout()}>Logout</Button>
              </div>
            }
            {!props.isAuthenticated &&
              <div>
                <Button variant="outlined" color="secondary" className={classes.buttonDefault} onClick={() => Login()}>Login</Button>
                <Button variant="contained" color="secondary" disableElevation onClick={() => Register()}>Register</Button>
              </div>
            }
          </Grid>
        </Grid>
      </Container>
    </AppBar >
  );
}
